import { ArrowRight } from 'lucide-react'
import { toGO } from '../navBar'

export default function GuideSection() {
  return (
    <div className='px-4 md:px-6 py-8 md:py-12 max-w-7xl mx-auto'>
      {/* Mobile View - Full Width Column */}
      <div className='md:hidden text-center pt-12'>
        <h1 className='text-5xl font-bold leading-tight'>
          Trade
          <br />
          the future
        </h1>
        <p className='mt-6 text-xl text-gray-600 px-4'>
          Buy, sell, and store over 350 digital assets at one of Europe's leading exchanges.
        </p>
        <button
          onClick={toGO}
          className='w-full mt-8 px-6 py-4 text-lg text-white bg-blue-600 rounded-xl hover:bg-blue-700 flex items-center justify-center'>
          Start Trading <ArrowRight className='ml-2 w-5 h-5' />
        </button>
      </div>

      {/* Desktop View - Two Columns */}
      <div className='hidden md:flex'>
        <div className='w-1/2 pt-20'>
          <h1 className='text-6xl font-bold leading-tight'>
            Trade
            <br />
            the future
          </h1>
          <p className='mt-6 text-xl text-gray-600'>Buy, sell, and store over 350 digital assets at one of Europe's leading exchanges.</p>
          <button onClick={toGO} className='px-6 py-3 mt-8 text-white bg-blue-600 rounded-lg hover:bg-blue-700 flex items-center'>
            Start Trading <ArrowRight className='ml-2 w-5 h-5' />
          </button>
        </div>

        <div className='w-1/2'>
          <img
            src='https://media.graphassets.com/output=format:avif/8efHf0wRoS5sWf7umHdg'
            alt='Trading Platform'
            className='w-full h-auto'
          />
        </div>
      </div>
    </div>
  )
}
